import React from "react";
import './courseCard.scss';
import {useNavigate} from "react-router-dom";
import {Button} from "../button/Button";

export interface CourseCardProps {
    image: any,
    heading: string,
    description: string,
    isDone: boolean,
    link: string
}

export const CourseCard: React.FC<CourseCardProps> = ({image, heading, description, isDone, link}) => {
    const navigate = useNavigate();
    return (
        <div className={'course_card'}>
            <div className={'course_card_top'}>
                <img src={image} alt=""/>
            </div>
            <div className={'course_card_body'}>
                <h1>{heading}</h1>
                <p>{description}</p>
            </div>
            <div className={'course_card_cta'}>
                <Button classStyle={isDone ? "button_complete" : ''} text={isDone ? 'Completed!' : 'Get Start!'}
                        type={'primary'} onclick={() => navigate(link)}/>
            </div>
        </div>
    );
}